import React from 'react';
import { ButtonGroup, DropdownButton, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'underscore';
import * as Fi from 'react-icons/fi';

import { Table } from 'services/action';
import UpdateItems from './update.items';
import { FormUpdatePricing } from '../form/price';
import { FormReason } from '../form/reason';
import { isNotClient } from 'utilities/common';

const initialState = {
  privilege: null,
  isShow: false,
  showPrice: false,
  showVoid: false
};

const Action = ({ data }) => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const StateTable = useSelector((state) => state?.Table?.data['shipment']);

  const [{ isShow, privilege, showPrice, showVoid }, setState] =
    React.useState(initialState);

  const $getPrivilege = async () => {
    const payload = {};

    const delivery = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.delivery',
    });

    const pricing = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.pricing',
    });

    if (pricing) {
      payload.pricing = pricing;
    }

    if (delivery) {
      payload.delivery = delivery;
    }

    setState((prevState) => ({ ...prevState, privilege: payload }));
  };

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      showPrice: false,
      showVoid: false
    }));
  };

  React.useEffect(() => {
    $getPrivilege();
  }, [Session]);

  if (isNotClient(Session?.client?.id, data?.order?.client?.id)) {
    return (
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id={`tooltip-top`}>Detil</Tooltip>}
      >
        <Link
          className="btn btn-light px-2"
          role="button"
          to={`/order/shipment/${data?.id}`}
        >
          <Fi.FiArrowRight />
        </Link>
      </OverlayTrigger>
    );
  }

  return (
    <>
      <DropdownButton
        as={ButtonGroup}
        variant="transparent"
        size="md"
        className="no-carret tbl-action"
        title={<Fi.FiMoreVertical size={13} color="gray" />}
      >
        {data?.shipment?.type === 'ltl' && (
          <Link
            className="dropdown-item d-flex align-items-center"
            role="button"
            to={`/order/shipment/${data?.id}`}
          >
            <Fi.FiClipboard size={15} color="#202020" className="me-2" />
            Lihat Detil
          </Link>
        )}

        {data?.order?.id && (
          <Link
            className="dropdown-item d-flex align-items-center"
            role="button"
            to={`/order/${data?.order?.id}`}
          >
            <Fi.FiClipboard size={15} color="#202020" className="me-2" />
            Lihat Dokumen Order
          </Link>
        )}

        {data?.document_status !== 'voided' && (
          <>
            {(!Session?.privileges || privilege?.delivery?.action === 'manage') && (
              <>
                <UpdateItems
                  data={data}
                  onClose={() => Dispatch(Table.$reload('shipment', StateTable))}
                />

                {(!Session?.privileges || privilege?.pricing) && (
                  <div
                    className="dropdown-item d-flex align-items-center cursor-pointer"
                    onClick={() => {
                      setState((prevState) => ({ ...prevState, showPrice: true }));
                    }}
                  >
                    <Fi.FiCreditCard size={15} color="#202020" className="me-2" />
                    Perbaharui Harga
                  </div>
                )}


                {((data?.document_status === 'new' || data?.document_status === 'console' || data?.document_status === 'disputed') && data?.shipment?.type === 'ltl') && (
                  <div
                    className="dropdown-item d-flex align-items-center cursor-pointer"
                    onClick={() => {
                      setState((prevState) => ({ ...prevState, showVoid: true }));
                    }}
                  >
                    <Fi.FiX size={15} color="#202020" className="me-2" />
                    Batalkan Shipment
                  </div>
                )}
              </>
            )}

            <DropdownButton
              as={ButtonGroup}
              variant="transparent"
              size="md"
              drop="start"
              className="no-carret"
              show={isShow}
              onMouseEnter={() =>
                setState((prevState) => ({ ...prevState, isShow: true }))
              }
              onMouseLeave={() =>
                setState((prevState) => ({ ...prevState, isShow: false }))
              }
              title={
                <div className="dropdown-item text-black">
                  <Fi.FiPrinter size={15} color="#202020" className="me-2" />
                  Print
                </div>
              }
            >
              <Link
                className="dropdown-item d-flex align-items-center"
                role="button"
                to={`/print/shipment/${data?.id}`}
                target="_blank"
              >
                <Fi.FiPrinter size={15} color="#202020" className="me-2" />
                Print Surat Muat
              </Link>
              <Link
                className="dropdown-item d-flex align-items-center"
                role="button"
                to={`/print/resi/${data?.id}`}
                target="_blank"
              >
                <Fi.FiPrinter size={15} color="#202020" className="me-2" />
                Print Resi
              </Link>
            </DropdownButton>
          </>
        )}
      </DropdownButton>

      {/* modal delete */}
      <Modal
        show={showVoid}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dibatalkan tidak bisa diproses ulang
          </p>

          <FormReason
            data={data}
            onSubmit={() => {
              Dispatch(Table.$reload('shipment', StateTable))
              $handleClose();
            }}
          />
        </Modal.Body>

      </Modal>

      {/* modal update harga */}
      <Modal
        show={showPrice}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-primary" />
          <h3 className="text-center mb-3">Update harga</h3>
          <FormUpdatePricing
            data={data}
            onSubmit={() => {
              Dispatch(Table.$reload('shipment', StateTable));
              $handleClose();
            }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Action;
